// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Warning = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <path d="M24,5.2,24,3.1L2,44.9h44L24,3.1h0Z" />
      <line x1="24" y1="19.3" x2="24" y2="32.5" />
      <circle cx="24" cy="37.7" r=".5" />
    </svg>
  );
};
